import "./App.css";
import Projects from "./Component/Projects/projects";
import Experience from "./Component/Experience/experience";

import { Link } from "react-router-dom";
import { useRef, useState, useEffect } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { faArrowRight, faArrowUp } from "@fortawesome/free-solid-svg-icons";

function App() {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [showSpotlight, setShowSpotlight] = useState(false);
  const [activeSection, setActiveSection] = useState("");

  const aboutSection = useRef(null);
  const experienceSection = useRef(null);
  const projectSection = useRef(null);
  const skillsSection = useRef(null);
  const resumeSection = useRef(null);

  const scrollToSection = (elementRef) => {
    window.scrollTo({
      top: elementRef.current.offsetTop,
      behavior: "smooth",
    });
  };

  const handleMouseMove = (e) => {
    setPosition({
      x: e.clientX + window.scrollX,
      y: e.clientY + window.scrollY,
    });
    setShowSpotlight(true);
  };

  const handleMouseLeave = () => {
    setShowSpotlight(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 200; // offset for better detection

      const sections = [
        { ref: aboutSection, name: "about" },
        { ref: experienceSection, name: "experience" },
        { ref: projectSection, name: "projects" },
        { ref: skillsSection, name: "skills" },
        { ref: resumeSection, name: "resume" },
      ];

      let currentSection = "";

      sections.forEach((section) => {
        if (section.ref.current) {
          const sectionTop = section.ref.current.offsetTop;
          const sectionHeight = section.ref.current.offsetHeight;

          if (
            scrollPosition >= sectionTop &&
            scrollPosition < sectionTop + sectionHeight
          ) {
            currentSection = section.name;
          }
        }
      });

      setActiveSection(currentSection);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Call once to set initial state

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className="App spotlight-container"
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      {showSpotlight && (
        <div
          className="spotlight"
          style={{ top: position.y, left: position.x }}
        ></div>
      )}

      {/* main page */}
      <main className="main ">
        {/* left-side */}

        <div className="left">
          {/* Name & role */}
          <div className="nested-left">
            <div className="head">
              <h2>Vinayak Shinde</h2>
              <h5>Full Stack Developer</h5>
            </div>

            {/* Short Description */}
            <div className="short-des">
              <p>
                I specialize in designing and building <br /> user-friendly
                applications that cover <br /> the full stack of technologies.
              </p>
            </div>

            {/* Navigation */}
            <div className="nav-list">
              <ul>
                <li
                  onClick={() => scrollToSection(aboutSection)}
                  className={`nav ${activeSection === "about" ? "active" : ""}`}
                >
                  <div className="line"></div>
                  <p>ABOUT</p>
                </li>
                <li
                  onClick={() => scrollToSection(experienceSection)}
                  className={`nav ${
                    activeSection === "experience" ? "active" : ""
                  }`}
                >
                  <div className="line"></div>
                  <p>EXPERIENCE</p>
                </li>
                <li
                  onClick={() => scrollToSection(projectSection)}
                  className={`nav ${
                    activeSection === "projects" ? "active" : ""
                  }`}
                >
                  <div className="line"></div>
                  <p>PROJECTS</p>
                </li>
                <li
                  onClick={() => scrollToSection(skillsSection)}
                  className={`nav ${
                    activeSection === "skills" ? "active" : ""
                  }`}
                >
                  <div className="line"></div>
                  <p>SKILLS</p>
                </li>
                <li
                  onClick={() => scrollToSection(resumeSection)}
                  className={`nav ${
                    activeSection === "resume" ? "active" : ""
                  }`}
                >
                  <div className="line"></div>
                  <p>RESUME</p>
                </li>
              </ul>
            </div>

            {/* social handles */}

            <div className="socials">
              <Link to="https://github.com/vinayak1809" target="_blank">
                <FontAwesomeIcon className="icon" icon={faGithub} />
              </Link>
              <Link to="https://www.linkedin.com/in/vinayaks18" target="_blank">
                <FontAwesomeIcon className="icon" icon={faLinkedinIn} />
              </Link>
              <Link to="mailto:vinayakrshinde18@gmail.com" target="_blank">
                <FontAwesomeIcon className="icon" icon={faEnvelope} />
              </Link>
            </div>
          </div>
        </div>
        {/* right-side */}
        <div className="right">
          {/* About */}
          <div ref={aboutSection} className="about">
            <h3>About</h3>
            <p>
              Hello, I’m Vinayak Shinde — a Computer Applications post-graduate,
              currently working at a startup. I’m passionate about building
              <span className="highlight"> full-stack applications</span> and
              constantly exploring new technologies. Recently, my focus has
              shifted toward experimenting with
              <span className="highlight"> AI concepts</span> and building
              solutions using the
              <span className="highlight"> Python and JavaScript.</span> <br />
              <br />
              At work, I’m involved in developing full-stack applications and
              AI-driven products, particularly around
              <span className="highlight">
                {" "}
                Retrieval-Augmented Generation (RAG) systems
              </span>
              . I work with various large language models (LLMs), integrating
              them into real-world products, and deploying these solutions on
              cloud platforms like
              <span className="highlight"> GCP and AWS</span>. A key part of my
              role is ensuring these systems are not only functional but also
              scalable and production-ready.
              <br />
              <br />
              Outside of tech, I recharge by playing football, reading books,
              and listening to music. These hobbies keep me grounded and
              inspired beyond the screen.
            </p>
          </div>

          {/* Projects */}

          <Experience experienceSection={experienceSection} />

          {/* Projects */}

          <Projects projectSection={projectSection} />

          {/* Skills */}

          <div ref={skillsSection} className="skills">
            <h3>Skills</h3>
            <ul>
              <li>Python</li>
              <li>JavaScript</li>
              <li>Node.js</li>
              <li>Nest.js</li>
              <li>React.js</li>
              <li>Next.js</li>
              <li>MongoDB</li>
              <li>MySQL</li>
              <li>Git</li>
              <li>AWS</li>
              <li>GCP</li>
              <li>Linux</li>
            </ul>
          </div>

          {/* resume */}
          <div ref={resumeSection} className="resume">
            <Link
              to="https://docs.google.com/document/d/1Y19elFoqMrmm0terSO4QJHUo_gPL3xqmUhbPgGCN1t4/edit"
              target="_blank"
            >
              <p>View my Resume</p>
              <FontAwesomeIcon className="re-icon" icon={faArrowRight} />
            </Link>
          </div>

          {/* just user info */}

          <div className="info">
            <p>
              Crafted with a relaxed design approach in Figma and coded using
              Visual Studio Code. Developed utilizing React.js and CSS, and
              seamlessly deployed through Vercel.
            </p>
          </div>

          {/* footer */}
          <div className="footer">
            <p>
              Created By,
              <br /> Vinayak Shinde
            </p>
            <FontAwesomeIcon
              onClick={() => scrollToSection(aboutSection)}
              className="icon-top"
              icon={faArrowUp}
            />
          </div>
        </div>
      </main>
    </div>
  );
}

export default App;
